// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.wallet.client

import org.multipaz.cbor.DataItem
import org.multipaz.wallet.client.WalletClientProvisionedDocumentOpenID4VCI
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.Bstr

fun WalletClientProvisionedDocumentOpenID4VCI.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "CDhA83YgJmBsXwxbV2GJoxO5CHCLS3cbV0m0rI-WR-Q")
val WalletClientProvisionedDocumentOpenID4VCI_cborSchemaId = ByteString(8, 56, 64, -13, 118, 32, 38, 96, 108, 95, 12, 91, 87, 97, -119, -93, 19, -71, 8, 112, -117, 75, 119, 27, 87, 73, -76, -84, -113, -106, 71, -28)

fun WalletClientProvisionedDocumentOpenID4VCI.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("type", "OpenID4VCI")
    builder.put("identifier", Tstr(this.identifier))
    val cardArt = this.cardArt
    if (cardArt != null) {
        builder.put("cardArt", Bstr(cardArt.toByteArray()))
    }
    val displayName = this.displayName
    if (displayName != null) {
        builder.put("displayName", Tstr(displayName))
    }
    val typeDisplayName = this.typeDisplayName
    if (typeDisplayName != null) {
        builder.put("typeDisplayName", Tstr(typeDisplayName))
    }
    builder.put("url", Tstr(this.url))
    builder.put("credentialId", Tstr(this.credentialId))
    return builder.end().build()
}

fun WalletClientProvisionedDocumentOpenID4VCI_fromDataItem(dataItem: DataItem): WalletClientProvisionedDocumentOpenID4VCI {
    val identifier = dataItem["identifier"].asTstr
    val cardArt0 = if (dataItem.hasKey("cardArt")) {
        dataItem["cardArt"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val displayName0 = if (dataItem.hasKey("displayName")) {
        dataItem["displayName"].asTstr
    } else {
        null
    }
    val typeDisplayName0 = if (dataItem.hasKey("typeDisplayName")) {
        dataItem["typeDisplayName"].asTstr
    } else {
        null
    }
    val url = dataItem["url"].asTstr
    val credentialId = dataItem["credentialId"].asTstr
    return WalletClientProvisionedDocumentOpenID4VCI(
        identifier = identifier,
        cardArt = cardArt0,
        displayName = displayName0,
        typeDisplayName = typeDisplayName0,
        url = url,
        credentialId = credentialId,
    )
}
